import { render, staticRenderFns } from "./InvestmentInfoBoxesContainer.vue?vue&type=template&id=960fa748"
import script from "./InvestmentInfoBoxesContainer.vue?vue&type=script&lang=js"
export * from "./InvestmentInfoBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./InvestmentInfoBoxesContainer.vue?vue&type=style&index=0&id=960fa748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports